var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listpanel-container" },
    [
      _c(
        "div",
        { staticClass: "listpanel-container__header" },
        [_vm._t("header")],
        2
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        _vm._b(
          { staticClass: "custom-card", attrs: { type: "border-card" } },
          "el-tabs",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.title } },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e77a106", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e77a106","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListPanel.vue
// module id = null
// module chunks = 